import module from 'app/module.js'

module.run(($rootScope, $window, AppBreadcrumbs) => {
  const original_title = $window.document.title

  $rootScope.$on('$stateChangeSuccess', () => {
    AppBreadcrumbs.update()
      .then((title) => ($window.document.title = title || original_title))
  })
})



// WEBPACK FOOTER //
// ./src/app/run.js